<template>
  <div class="textarea-wrap">
    <span class="textarea-symbol__amount" v-show="textAreaData.trim().length">{{
      textAreaData.trim().length
    }}</span>
    <textarea-autosize
      ref="textarea"
      v-if="isShowTextArea"
      :name="name"
      class="input textarea"
      :placeholder="placeholder"
      v-model="textAreaData"
      :disabled="disabled"
      :min-height="90"
    ></textarea-autosize>

    <div
      id="editableDiv"
      ref="editableDiv"
      class="fake-textarea"
      contenteditable="true"
      @input="showTextArea($event)"
      v-else
    >
      <pre
        ref="fixedTextContent"
        class="fake-textarea__content"
        v-html="highlightedText"
      ></pre>
      <div
        v-if="isSpellerBlockShown"
        class="speller-block"
        :style="spellerBlockPosition"
        v-click-outside="closeSpellerBlock"
      >
        <span
          v-for="(word, i) in spellerWords"
          :key="i"
          @click="replaceWord(word)"
        >
          {{ word.value }}
        </span>
      </div>
    </div>
    <div v-if="textAreaData.trim().length" class="container-center">
      <button
        class="textarea-button"
        type="button"
        @click.prevent="spellerCheck"
      >
        {{ $t("event.catalog.modal.spellerButton") }}
      </button>
      <p class="speller-note">
        {{ $t("event.catalog.modal.spellerNote1") }}
        <a href="http://api.yandex.ru/speller/" target="_blank">
          {{ $t("event.catalog.modal.spellerNote2") }}</a
        >
      </p>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      isShowTextArea: true,
      isSpellerBlockShown: false,
      errorsList: [],
      cursorPosition: 0,
      highlightedText: "",
      spellerWords: [],
      spellerBlockPosition: {}
    };
  },

  props: {
    name: String,
    placeholder: String,
    value: String,
    disabled: Boolean
  },

  methods: {
    async spellerCheck() {
      if (this.isShowTextArea) {
        const externalAxios = axios.create();
        const response = await externalAxios.get(
          "https://speller.yandex.net/services/spellservice.json/checkText",
          {
            params: {
              text: this.value
            }
          }
        );
        this.errorsList = response?.data;
        this.isShowTextArea = false;
        this.spellText();
      } else {
        return false;
      }
    },

    closeSpellerBlock() {
      this.isSpellerBlockShown = false;
    },
    setNewText() {
      const newText = this.$refs.fixedTextContent.innerText;
      this.$emit("input", newText);
    },
    replaceWord(word) {
      const targetSpan = document.getElementById(word.index);
      targetSpan.innerText = word.value;
      targetSpan.classList.remove("error");
      this.closeSpellerBlock();
      this.$nextTick(() => {
        this.setNewText();
      });
    },
    showTextArea(e) {
      this.getCursorPosition();
      this.setNewText();
      this.isShowTextArea = true;
      this.$nextTick(() => {
        const textArea = this.$refs.textarea.$el;
        textArea.focus();
        if (e.data === " ") {
          textArea.setSelectionRange(
            ++this.cursorPosition,
            this.cursorPosition
          );
        } else {
          textArea.setSelectionRange(this.cursorPosition, this.cursorPosition);
        }
      });
    },

    getCursorPosition() {
      const selection = window.getSelection();
      if (selection.rangeCount > 0) {
        const range = selection.getRangeAt(0);
        const preCaretRange = range.cloneRange();
        preCaretRange.selectNodeContents(this.$refs.editableDiv);
        preCaretRange.setEnd(range.endContainer, range.endOffset);
        this.cursorPosition = preCaretRange.toString().trim().length;
      }
    },
    spellText() {
      let updatedText = this.value;
      let htmlOffset = 0;
      this.errorsList.forEach((error, index) => {
        const { pos, len } = error;
        error.index = `spellerTextarea-${index}`;
        const word = this.value.substring(pos, pos + len);
        const wrappedWord = `<span id="spellerTextarea-${index}"  class="error" data-error='${JSON.stringify(
          error
        )}'>${word}</span>`;
        updatedText =
          updatedText.substring(0, pos + htmlOffset) +
          wrappedWord +
          updatedText.substring(pos + htmlOffset + len);
        htmlOffset += wrappedWord.length - word.length;
      });
      this.highlightedText = updatedText;
    },
    handleSpanClick(e) {
      const errorString = e.target.getAttribute("data-error");
      if (errorString) {
        const error = JSON.parse(errorString);
        this.spellerWords = error.s.map(item => {
          return {
            value: item,
            index: error.index
          };
        });
        this.setSpellerBlockPosition(error.index);
        this.isSpellerBlockShown = true;
      }
    },
    setSpellerBlockPosition(id) {
      const editableDiv = this.$refs.editableDiv.getBoundingClientRect();
      const spellerSpan = document.getElementById(id).getBoundingClientRect();
      this.spellerBlockPosition.top =
        spellerSpan.top - editableDiv.top + spellerSpan.height + "px";
      this.spellerBlockPosition.left =
        spellerSpan.left - editableDiv.left + "px";
    }
  },

  computed: {
    textAreaData: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },

  mounted() {
    document.addEventListener("click", this.handleSpanClick);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleSpanClick);
  }
};
</script>

<style lang="scss">
@import "@v2/app/styles/mixins";
@import "@v2/app/styles/media";
.textarea-wrap {
  position: relative;
}
.textarea-symbol__amount {
  position: absolute;
  right: 10px;
  bottom: 42px;
  font-weight: 600;
  color: #0066cc;
  z-index: 10;
  @include respond-down(sm) {
    bottom: 62px;
  }
}
.fake-textarea {
  position: relative;
  min-height: 90px;
  padding: 11px 16px 10px 16px;
  margin-bottom: 4px;
  border: 1px solid #cdced0;
  background-color: #ffffff;
  box-sizing: border-box;
  &__content {
    line-height: 18px;
    font-family: inherit;
    font-size: inherit;
    margin: 0;
    white-space: pre-wrap;
  }
  &:read-write:focus {
    outline: none;
  }
  &:hover {
    border: 1px solid #a3a8b3;
  }
  & .error {
    background-color: rgba(255, 0, 0, 0.3);
    padding: 2px 1px;
    margin: 0 1px;
    cursor: pointer;
    border-radius: 4px;
    transition: background-color 0.15s ease-in-out;
  }
  & .speller-block {
    position: absolute;
    background-color: rgb(230, 230, 230);
    list-style: none;
    border-radius: 5px;
    margin: 0;
    padding: 0;
    z-index: 10;
    & span {
      display: block;
      padding: 8px 8px;
      cursor: pointer;
      border-radius: 5px;
      &:hover {
        background-color: #979797;
      }
    }
  }
}
.input-label__input .textarea {
  line-height: 18px;
  padding-top: 12px;
  padding-right: 16px;
  padding-bottom: 10px;
}
.container-center {
  display: flex;
  justify-content: space-between;
  align-items: center;
  @include respond-down(sm) {
    flex-direction: column;
    align-items: flex-start;
  }
}
.textarea-button {
  @include button-clean();
  @include hyperlink();
}
.speller-note {
  margin: 5px 0 0 0;
  color: #6d7179;
  font-size: 12px;
  & a {
    color: inherit;
    @include hyperlink();
    font-size: inherit;
  }
}
</style>
